import { gql } from 'graphql-request'

export const GlobalSharedQuery = gql`
  query GlobalShared(
    $locale: LocaleInputType!
  ) {
    Shared(locale: $locale) {
      siteName
      tagline
      cookiesPolicy
      seoDescription
      coverImage ${fragmentMediaQuery}
    }
  }
`
